import script from "./promotion-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./promotion-modal.vue?vue&type=script&setup=true&lang=js"

import "./promotion-modal.vue?vue&type=style&index=0&id=89e4aae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e4aae8"]])

export default __exports__